var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container"},[_c('div',{staticClass:"tab-content",class:{ active: _vm.active === true, noHover: _vm.disabled === true },style:(_vm.containerStyle)},[_c('img',{attrs:{"src":_vm.image}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.disabled === true),expression:"disabled === true"}],staticClass:"hide"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }